module.exports = __webpack_public_path__ + "static/img/culture5.87d0f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture5.png
// module id = DCuw
// module chunks = 2